/* eslint-disable react/no-children-prop */
import { CreateAlbumModal } from "@/modules/album/components/CreateModal";
import { albumStore } from "@/modules/album/store";
import { themeStore } from "@/stores/theme";
import { AlbumWords } from "@/utils/lang/album";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import AlbumCard from "./AlbumCard";

interface Props {
  onSwitch: () => void;
}

function MyAlbum(props: Props) {
  useEffect(() => {
    albumStore.fetchAlbums();
  }, []);
  const [flag, flagOp] = useBoolean(false);
  const { tgt: lang, translate } = langStore;

  return (
    <Box>
      <Flex justify="flex-end" h="32px" mb="8px">
        <Box
          h="100%"
          color="#999999"
          border="1px solid"
          rounded="8px"
          px="16px"
          py="2px"
          cursor="pointer"
          onClick={flagOp.on}
        >
          +{translate(AlbumWords.newAlbum, lang)}
        </Box>
      </Flex>
      <Flex flexShrink={0} flexWrap="wrap">
        {albumStore.albumList.map((album) => {
          return (
            <AlbumCard
              id={album.id}
              preview={album.preview}
              name={album.name}
              total={album.image_count}
              key={album.id}
              onClick={props.onSwitch}
              isDefault={album.is_default === 1}
            />
          );
        })}
      </Flex>
      <CreateAlbumModal isOpen={flag} onClose={flagOp.off} />
    </Box>
  );
}

export default observer(MyAlbum);
